import React from 'react';
import i18n from '@i18next/i18n';

export const ReplaceImageDrawerTitle = () => (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'baseline', color: 'rgba(0,0,0,0.88)' }}>
        <div>{i18n.t('联网搜图')}</div>
        <div style={{ marginLeft: 4, fontSize: 12, color: 'rgba(0,0,0,0.24)' }}>{i18n.t('如需商用请自行获取授权')}</div>
    </div>
);
